import AuthService from 'services/AuthService'
import UserRolesEnum from '../enums/UserRolesEnum'

export default {
    handle(to, from, next) {
        AuthService.loadSession().then(() => {
            if (AuthService.getUser()?.userRole?.id === UserRolesEnum.ADMINISTRATOR.ID) {
                return next({ name: 'admin.claim-your-profile' })
            }
            next()
        })
    },
}
